import {
  createExtension,
  createRouteRef,
  coreExtensionData,
  createExtensionInput,
} from '@backstage/frontend-plugin-api';
import {
  homeWidgetTitleDataRef,
  homeWidgetPriorityDataRef,
  homeWidgetColumnDataRef,
} from './widgetDataRefs';
import { HomePage } from './HomePage';

export const homeRouteRef = createRouteRef();

export const HomePageExtension = createExtension({
  kind: 'page',
  name: 'appvia-home',
  attachTo: { id: 'app/routes', input: 'routes' },
  inputs: {
    // Accept widget extensions from third-party plugins
    widgets: createExtensionInput([
      coreExtensionData.reactElement,
      homeWidgetTitleDataRef.optional(),
      homeWidgetPriorityDataRef.optional(),
      homeWidgetColumnDataRef.optional(),
    ]),
  },
  output: [
    coreExtensionData.routePath,
    coreExtensionData.routeRef,
    coreExtensionData.reactElement,
  ],
  factory: ({ inputs }) => {
    // Collect widgets from extension inputs
    const widgets = inputs.widgets.map(widget => ({
      element: widget.get(coreExtensionData.reactElement),
      title: widget.get(homeWidgetTitleDataRef),
      priority: widget.get(homeWidgetPriorityDataRef) ?? 100,
      column: widget.get(homeWidgetColumnDataRef) ?? 'right',
    }));

    // Sort by priority (lower = appears first)
    widgets.sort((a, b) => a.priority - b.priority);

    // Group by column
    const leftWidgets = widgets.filter(w => w.column === 'left');
    const rightWidgets = widgets.filter(w => w.column === 'right');

    // Wrap HomePage in a component function so React lifecycle works correctly
    const HomePageWrapper = () => (
      <HomePage leftWidgets={leftWidgets} rightWidgets={rightWidgets} />
    );

    return [
      coreExtensionData.routePath('/'),
      coreExtensionData.routeRef(homeRouteRef),
      coreExtensionData.reactElement(<HomePageWrapper />),
    ];
  },
});
